import { useSelector } from 'react-redux';
import * as ModuleService from 'services/sales/module';

export const useModuleService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchModules = async (options = {}) => {
    const { error, payload } = await ModuleService.read({ ...options, token });
    if (error) {
      return { modules: [], size: 0 };
    }

    const {
      data: modules,
      meta: { size }
    } = payload;
    return { modules, size };
  };

  return {
    fetchModules
  };
};
